export default __webpack_public_path__ + "static/media/MritkalaLogo.e37a71d6.png";